var map = {
	"./alabama-rural-studio": 64,
	"./alabama-rural-studio.jsx": 64,
	"./cambridge-student-accommodation": 65,
	"./cambridge-student-accommodation.jsx": 65,
	"./crescent-extension": 66,
	"./crescent-extension.jsx": 66,
	"./dukes-park-renovation": 67,
	"./dukes-park-renovation.jsx": 67,
	"./hall-farm-holiday-lets": 68,
	"./hall-farm-holiday-lets.jsx": 68,
	"./hall-farm-threshing-barn": 69,
	"./hall-farm-threshing-barn.jsx": 69,
	"./long-road-student-centre": 70,
	"./long-road-student-centre.jsx": 70,
	"./new-mills-incubator": 71,
	"./new-mills-incubator.jsx": 71,
	"./sussex-street-mixed-use": 72,
	"./sussex-street-mixed-use.jsx": 72,
	"./willow-walk-extension": 73,
	"./willow-walk-extension.jsx": 73,
	"./willow-walk-remodelling": 74,
	"./willow-walk-remodelling.jsx": 74
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;


//////////////////
// WEBPACK FOOTER
// ./src/components/projects ^\.\/.*$
// module id = 174
// module chunks = 0